import { db } from "./firebase";
import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
  limit,
  serverTimestamp,
} from "firebase/firestore";

/**
 * Registra uma nova atividade no sistema
 * @param {string} acao - Tipo de ação (ex: "Novo certificado emitido", "Válvula cadastrada")
 * @param {string} alvo - Objeto da ação (ex: "PSV-001 • Petrobras")
 * @param {string} nomeUsuario - Nome do usuário que realizou a ação
 */
export const registrarAtividade = async (acao, alvo, nomeUsuario) => {
  try {
    await addDoc(collection(db, "atividades"), {
      acao,
      alvo,
      usuario: nomeUsuario || "Sistema",
      dataHora: serverTimestamp(),
    });
  } catch (error) {
    console.error("Erro ao registrar atividade:", error);
  }
};

/**
 * Busca as últimas atividades do sistema
 * @param {number} quantidade - Quantidade de atividades a buscar (padrão: 10)
 * @returns {Promise<Array>} Lista de atividades
 */
export const buscarAtividades = async (quantidade = 10) => {
  try {
    const q = query(
      collection(db, "atividades"),
      orderBy("dataHora", "desc"),
      limit(quantidade)
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Erro ao buscar atividades:", error);
    return [];
  }
};
